
import React from 'react';
import { Business } from '@/data/types/businessTypes';
import { LogoLayout } from '../useLogoUpload';

interface GoogleAdPreviewProps {
  business: Business;
  logoPreview: string | null;
  logoLayout: LogoLayout;
}

export const GoogleAdPreview: React.FC<GoogleAdPreviewProps> = ({
  business,
  logoPreview,
  logoLayout
}) => {
  // Generate logo display classes based on the selected layout
  const getLogoClasses = () => {
    switch (logoLayout) {
      case 'landscape':
        return "w-10 h-4 mr-2";
      case 'portrait':
        return "w-4 h-6 mr-2";
      case 'square':
      default:
        return "w-6 h-6 mr-2";
    }
  };
  
  return (
    <div className="w-full max-w-md border rounded shadow-md bg-white overflow-hidden">
      {/* Ad header */}
      <div className="flex items-center p-2 bg-gray-50">
        {logoPreview ? (
          <div className={getLogoClasses()}>
            <img src={logoPreview} alt="Business logo" className="w-full h-full object-contain" />
          </div>
        ) : null}
        <div className="text-xs text-gray-500 flex-1">
          <span className="text-green-700">Ad</span> · {business.websiteUrl || 'www.yourbusiness.com'}
        </div>
      </div>
      
      {/* Ad content */}
      <div className="p-2">
        <div className="text-blue-700 text-sm font-medium">
          {business.title || 'Your Business Name'} | {business.industry || 'Your Service'}
        </div>
        <div className="text-xs text-gray-800 my-1">
          Quality services from a trusted local business. Contact us today!
        </div>
        <div className="flex items-center text-xs text-gray-500 mt-1">
          <span className="mr-2">{business.cityName || 'City'}, {business.stateCode || 'State'}</span>
          <span>·</span>
          <span className="ml-2">{business.primaryPhone || '(555) 123-4567'}</span>
        </div>
      </div>
    </div>
  );
};
